<template>
	<div class="centerPage">
		<div class="search flex">
			<span class="tit">我的粉丝</span>
			<div class="flex">
				<el-input placeholder="姓名" clearable v-model="page.name" @change="skipPage(1)"></el-input>
				<el-button size="mini" @click="skipPage(1)">搜索</el-button>
			</div>
		</div>
		<div class="border">
			<el-table
					v-if="page.rows.length != 0"
					class="record-table"
					:data="page.rows"
					:header-cell-style="{'background':'rgba(86,123,255,0.1)','color':'#666','fontWeight':'400','textAlign':'center'}"
					height="calc(100vh - 357px)">
				<!--<el-table-column label="序号" type="index" align="center" width="80" show-overflow-tooltip></el-table-column>-->
				<el-table-column prop="fullName" align="center" label="姓名" show-overflow-tooltip></el-table-column>
				<el-table-column label="性别" align="center" width="70">
					<template slot-scope="scope">
						{{ scope.row.gender == 0 ? '女' : scope.row.gender == 1 ? '男': '-' }}
					</template>
				</el-table-column>
				<el-table-column prop="age" align="center" label="年龄" width="70"></el-table-column>
				<el-table-column prop="abodeCity" align="center" label="居住地" show-overflow-tooltip></el-table-column>
				
				<el-table-column prop="concernDate" label="关注时间" width="120" align="center">
					<template slot-scope="scope">{{new Date(Number(scope.row.concernDateTimestamp+'000')).Format('yyyy-MM-dd')}}</template>
				</el-table-column>
				<el-table-column
						label="操作"
						width="260"
						align="center">
					<template slot-scope="scope">
						<el-button size="mini" class="orange-transparent" @click="toChat(scope.row.id)" :loading="buttonLoading.chat">私信</el-button>
<!--						<el-button size="mini" class="blue" @click="toDetail(scope.row.id)">详情</el-button>-->
					</template>
				</el-table-column>
			</el-table>
			<div class="empty" v-else>
				<img src="../../assets/img/no.png" alt="" width="200">
				<p>这里什么都没有</p>
			</div>
			<el-pagination
					class="pagination"
					background
					prev-text="Prev"
					next-text="Next"
					@current-change="skipPage"
					:current-page="page.current"
					:page-size="page.size"
					layout="prev, pager, next"
					:total="page.total">
			</el-pagination>
		</div>
	
	</div>
</template>

<script>
import base from '@/api/common';
export default {
	name: "follower",
	data(){
	  return{
			page:{
	      current: 1,
				size: 10,
        total: 8,
				rows:[],
				name: '',
			},
			buttonLoading: {
			  chat: false,
			},
		}
	},
	mounted() {
	 	this.skipPage(1)
  },
	methods:{
    skipPage(current){
      this.page.current = 1;
      this.getData();
		},
    getData(){
      let that = this;
      that.$ajax.get(base.basePath + 'auth/user-concern/authorize/follower/page',{params:{
    	  	page: that.page.current,
					size: that.page.size,
					name: that.page.name
				}}).then(res=>{
				  if(res.data.status === 'success'){
				    that.page.rows = res.data.rows;
					}else{
				    that.$message.error('数据加载失败');
					}
			});
		},
    toChat(userId){
      let that = this;
      if (userId) {
        that.buttonLoading.chat = true;
        that.$ajax.post(base.api.communication.chat.create.replace('{uid}', userId)).then(res => {
          that.buttonLoading.chat = false;
          if (res.data.status === 'success') {
            if (res.data.userType == 1) {
              that.$router.push({name: 'communicate', params: {id: res.data.id}});
            } else if (res.data.userType == 2) {
              that.$router.push({name: 'communicateDoc', params: {id: res.data.id}});
            } else {
              that.$message.error('error');
            }
          } else {
            that.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          that.$message.error('失败');
        })
      }
		},
    toDetail(userId){
      // console.log(userId);
    },
	}
}
</script>

<style scoped lang="scss">
	@import '../../assets/css/patients.scss';
	
	.orange-transparent {
		background: transparent;
		border-color: #FF7C2F;
		color: #FF7C2F;
	}
	.orange {
		border-color: #FF7C2F;
		background-color: #FF7C2F;
		color: #FFFFFF;
	}

</style>